module.exports = __webpack_public_path__ + "img/rewind_time.35fb779a.svg";